import { render, staticRenderFns } from "./PowerDensity.vue?vue&type=template&id=39a61d37&scoped=true"
import script from "./PowerDensity.vue?vue&type=script&lang=js"
export * from "./PowerDensity.vue?vue&type=script&lang=js"
import style0 from "./PowerDensity.vue?vue&type=style&index=0&id=39a61d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a61d37",
  null
  
)

export default component.exports